import React from 'react';
import { getApplicantCitizenship } from '../index';
import {
  bindClaimAccidentCarListData,
  bindClaimApplicantData,
  bindClaimAttachmentsData,
  bindClaimPayloadData,
  bindClaimTransportData,
  bindParticipantData,
  bindVictimData,
  formatDate,
  bindClaimFormProperties,
} from '../claimApplicationHelpers';
import { APPLICANT_TYPES, TRANSFER_TYPES } from '../../../constants';

export const searchApplicant = (data, clearError, onSearch) => {
  const preparedData = data;

  if (preparedData.ssn) {
    delete preparedData.pnum;
  } else {
    delete preparedData.ssn;
  }

  if (preparedData.policy) {
    delete preparedData.tpnum;
  } else {
    delete preparedData.policy;
  }

  clearError();
  onSearch(preparedData);
};

export const updateCascoClaimForm = (
  applicant,
  policies,
  status,
  countries,
  dispatch,
  updateCascoForm,
) => {
  if (applicant && policies) {
    const properties = bindClaimFormProperties(applicant, policies, countries);
    dispatch(
      updateCascoForm({
        name: 'personalData',
        data: {
          applicantType: status,
          ...properties.bindPersonalData(),
        },
      }),
    );
    dispatch(
      updateCascoForm({
        name: 'accidentInfo',
        data: properties.bindAccidentInfo(),
      }),
    );
    dispatch(
      updateCascoForm({
        name: 'compensation',
        data: {
          isPhysicalEntity: status === 1,
          ...properties.bindCompensation(),
        },
      }),
    );
    dispatch(
      updateCascoForm({
        name: 'conclusion',
        data: {
          ...properties.bindConclusion(),
          citizenship: getApplicantCitizenship(status, applicant.country, countries)
            .citizenship,
        },
      }),
    );
  }
};

export const prepareCascoPayload = (data) => {
  const {
    personalData,
    accidentInfo,
    conclusion,
    attachments: formAttachments,
    language,
    compensation,
  } = data;
  const victim = bindVictimData(personalData);
  const applicant = bindClaimApplicantData(personalData);
  const payload = bindClaimPayloadData(personalData, applicant, language);

  const isApplicantPhysicalEntity = personalData.applicantType === APPLICANT_TYPES[0].value;

  victim.type = isApplicantPhysicalEntity ? APPLICANT_TYPES[0].key : APPLICANT_TYPES[1].key;
  victim.organizationName = personalData.organizationName;
  victim.taxIdNumber = personalData.hvhh;

  payload.victim = victim;

  payload.participantIs = personalData.participantIs;
  payload.participant = bindParticipantData(payload, personalData);
  if (accidentInfo.carList) {
    payload.vehicles = bindClaimAccidentCarListData(accidentInfo);
  }

  payload.applicantResidenceCountry = personalData.applicantResidenceCountry;
  payload.applicantResidenceState = personalData.applicantResidenceState;
  payload.applicantResidenceCityVillage = personalData.applicantResidenceCityVillage;
  payload.applicantResidenceStreet = personalData.applicantResidenceStreet;

  payload.accidentDate = formatDate(accidentInfo.accidentDate);
  payload.accidentTime = accidentInfo.accidentTime;
  payload.accidentCountry = accidentInfo.accCountry;
  payload.accidentState = accidentInfo.accState;
  payload.accidentCityVillage = accidentInfo.accVillage;
  payload.accidentStreet = accidentInfo.accStreet;
  payload.accidentLegalProceeding = accidentInfo.proceedingStatus;

  bindClaimTransportData(payload, personalData, accidentInfo);
  payload.damageCost = accidentInfo.damageAmount;
  payload.damagedParts = accidentInfo.damagedParts;
  payload.accidentDetails = accidentInfo.accidentDetails;

  payload.email = conclusion.email;
  payload.emailConfirmation = conclusion.emailConfirmation;
  payload.phone = conclusion.phone || null;
  payload.cellPhone = conclusion.cellPhone || null;
  payload.receivedCompensationSum = conclusion.receivedCompensationSum;

  payload.transferType = compensation.transferType;
  payload.transferBank = compensation.transferBank;
  payload.transferAccount = compensation.transferType === TRANSFER_TYPES[1].value
    ? compensation.transferAccount : null;

  payload.paymentReceiverIs = personalData.applicantIs;
  payload.paymentReceiver = payload.applicant;

  payload.attachments = bindClaimAttachmentsData(formAttachments);
  payload.language = language;
  payload.contractNumber = accidentInfo.contract.policyNumber;

  return payload;
};

export const bindClaimConclusionSuccessTableData = (data) => {
  const { policyNumber } = data.personalData;

  return [
    {
      title: 'claim.conclusion.successTable.contractNumber',
      data: policyNumber,
      divider: <hr />,
    },
    {
      title: 'claim.conclusion.successTable.insuredManufacturer',
      data: (
        <span>
          {data.personalData.transportManufacturer.name}
          {' '}
          {data.personalData.transportModel.name}
        </span>
      ),
      divider: <hr />,
    },
    {
      title: 'claim.conclusion.successTable.accidentDetails',
      data: (
        <span>{data.accidentInfo.accidentDetails}</span>
      ),
      divider: <hr />,
    },
    {
      title: 'claim.conclusion.successTable.damagedParts',
      data: <div>{data.accidentInfo.damagedParts}</div>,
      divider: <hr />,
    },
    {
      title: 'claim.conclusion.successTable.damageAmount',
      data: (
        <span>{data.accidentInfo.damageAmount}</span>
      ),
      divider: <hr />,
    },
  ];
};
